import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ReservationsService } from '@/services/reservations'
import { toast } from 'sonner'
import { SIMULATED_UPDATE_TOAST } from '@/lib/beds24-simulated-toast'

export function useUpdateReservation() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async ({ id, data }: { id: string; data: any }) => {
            const response = await ReservationsService.update(id, data)
            if (!response.success) {
                throw new Error(response.message || 'Error en actualitzar la reserva')
            }
            return response
        },
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ['reservations'] })
            queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] })
            queryClient.invalidateQueries({ queryKey: ['upcoming-reservations'] })
            
            // Mostrar toast amb info de sync Beds24
            const data = response.data
            if (data?.beds24Simulated === true) {
                // Fora de producció el backend no escriu a Beds24: desat en local i prou. Arriba
                // amb `beds24SyncError` ple, però no és cap error (a producció no hi és mai).
                toast.warning(SIMULATED_UPDATE_TOAST.title, {
                    description: SIMULATED_UPDATE_TOAST.description,
                    duration: 5000,
                })
            } else if (data?.beds24Synced) {
                toast.success('Reserva actualitzada i sincronitzada a Beds24 ✅')
            } else if (data?.beds24SyncError) {
                toast.warning('Reserva guardada localment', {
                    description: `⚠️ Error sync Beds24: ${data.beds24SyncError}`,
                    duration: 5000,
                })
            } else if (data?.beds24_id) {
                // Té beds24_id però no s'ha sincronitzat (no hi havia canvis per sincronitzar)
                toast.success('Reserva actualitzada correctament')
            } else {
                // Reserva local (sense beds24_id)
                toast.success('Reserva actualitzada correctament')
            }
        },
        onError: (error: any) => {
            console.error('Error updating reservation:', error)
            toast.error(error.message || 'Error en actualitzar la reserva')
        },
    })
}
